export enum TaskTabs {
  ALL_TASKS = 'All Tasks',
  MY_TASKS = 'My Tasks',
  DRAFTS = 'Drafts',
}

export type TaskStatus =
  | 'IN_PROGRESS'
  | 'AWAITING_APPROVAL'
  | 'DONE'
  | 'CANCELLED'
  | 'DRAFT'

export type TaskSource = 'OBSERVATION'

export type TaskPermittedActions =
  | 'READ'
  | 'EDIT'
  | 'REOPEN'
  | 'REASSIGN'
  | 'SUBMIT_STEP'
  | 'CANCEL'
  | 'REQUEST_CHANGES'

// Object containing all TaskStatus values for reference and iteration
export const TASK_STATUSES: Record<string, TaskStatus> = {
  IN_PROGRESS: 'IN_PROGRESS',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  DONE: 'DONE',
  CANCELLED: 'CANCELLED',
  DRAFT: 'DRAFT',
}
